import { motion } from "framer-motion";
import { ContactForm } from "./ContactForm";
import { useLang } from "../i18n";

export const Contact = () => {
  const { t } = useLang();

  return (
    <section id="iletisim" data-testid="contact-section" className="relative py-24 md:py-32 scroll-mt-24 overflow-hidden">
      <div aria-hidden className="absolute inset-0 -z-10 pointer-events-none bg-white">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(123,160,91,0.07),transparent_32%),radial-gradient(circle_at_bottom_right,rgba(198,125,87,0.07),transparent_30%)]" />
      </div>
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 md:mb-16 text-center">
          <p className="font-sans uppercase tracking-[0.3em] text-xs text-[#7BA05B] mb-6">{t("contact.label")}</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tighter text-[#1A1715] leading-none">
            {t("contact.headingPre")}<span className="italic text-[#6B6560]">{t("contact.headingItalic")}</span>
          </h2>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.1 }}
          className="max-w-2xl mx-auto rounded-2xl bg-white ring-1 ring-[#2F4A26]/25 border-t-4 border-[#2F4A26] shadow-[0_12px_40px_rgba(47,74,38,0.12)] p-7 md:p-10 flex flex-col"
        >
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-[#2F4A26]" />
              <span className="font-sans uppercase tracking-[0.25em] text-[10px] text-[#2F4A26]">{t("contact.formTitle")}</span>
            </div>
            <p className="text-[#6B6560] leading-relaxed">{t("contact.formDesc")}</p>
          </div>
          <ContactForm light />
        </motion.div>
      </div>
    </section>
  );
};
